import { render, staticRenderFns } from "./addActivitiesView.vue?vue&type=template&id=0af63111&scoped=true"
import script from "./addActivitiesView.vue?vue&type=script&lang=js"
export * from "./addActivitiesView.vue?vue&type=script&lang=js"
import style0 from "./addActivitiesView.vue?vue&type=style&index=0&id=0af63111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af63111",
  null
  
)

export default component.exports